export default __webpack_public_path__ + "a820f961fa57cb5a653f7a6a76fc508f.webp";